import { useEffect, useMemo, useState } from 'react';
import { toast } from 'sonner';
import { GetAgentResponse } from '@mastra/client-js';
import { createMastraClient } from '../lib/mastra-client';
import { useAuth } from '../../../providers/authentication-provider';

// export const useAgents = () => {
//     const [agents, setAgents] = useState<Record<string, GetAgentResponse>>({});
//     const [isLoading, setIsLoading] = useState(true);
//     const {
//         authState: { tokenResult },
//     } = useAuth();
//     const client = useMemo(
//         () => createMastraClient({ token: tokenResult?.token || '', selectedModel: undefined }),
//         [tokenResult?.token]
//     );
//     useEffect(() => {
//         const fetchAgents = async () => {
//             setIsLoading(true);
//             try {
//                 const res = await client.getAgents();
//                 setAgents(res);
//             } catch (error) {
//                 setAgents({});
//                 console.error('Error fetching agents', error);
//                 toast.error('Error fetching agents');
//             } finally {
//                 setIsLoading(false);
//             }
//         };

//         fetchAgents();
//     }, []);

//     return { agents, isLoading };
// };

export const useAgent = (agentId: string, selectedModel?: string) => {
    const [agent, setAgent] = useState<GetAgentResponse | null>(null);
    const [availableAgents, setAvailableAgents] = useState<string[]>([]);
    const [isLoading, setIsLoading] = useState(true);
    const {
        authState: { tokenResult },
    } = useAuth();
    const client = useMemo(
        () => createMastraClient({ token: tokenResult?.token || '', selectedModel: selectedModel }),
        [tokenResult?.token, selectedModel]
    );

    useEffect(() => {
        const fetchAgent = async () => {
            setIsLoading(true);
            try {
                if (!agentId) {
                    setAgent(null);
                    setIsLoading(false);
                    return;
                }
                const [res, availableAgents] = await Promise.all([
                    client.getAgent(agentId).details(),
                    client.getAgents(),
                ]);
                setAgent(res);
                setAvailableAgents(Object.keys(availableAgents));
            } catch (error) {
                setAgent(null);
                console.error('Error fetching agent', error);
                toast.error('Error fetching agent');
            } finally {
                setIsLoading(false);
            }
        };

        fetchAgent();
    }, [agentId]);

    return { agent, isLoading, availableAgents, mastra: client };
};
